// extracted by mini-css-extract-plugin
export default {"checkRunStatusContainer":"CheckRunStatus-module__checkRunStatusContainer--yY4j1"};